import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { GridViewModel, GridRowAction } from 'tessa/ui/cards/controls';
import { Guid, DbType, createTypedField, DotNetType } from 'tessa/platform';
import { openCard, showViewsDialog } from 'tessa/ui/uiHost';
import { RequestParameterBuilder } from 'tessa/views';
import { ViewParameterMetadata, equalsCriteriaOperator, RequestParameter } from 'tessa/views/metadata';
import { CardRow, CardRowState } from 'tessa/cards';
import { CdCardTypes } from '../Helpers/CdCardTypes';
import { CdCommonHelper } from '../Helpers/CdCommonHelper';
import { UIButton } from 'tessa/ui';
import { PkCardTypes } from 'src/pkScripts/Helpers/PkCardTypes';
import { NamedEntry } from '../Helpers/NamedEntry';
import { CdReferenceTypes } from '../Helpers/CdReferenceTypes';
import { CdDocStates } from '../Helpers/CdDocStates';

export class CdRefsTableUIExtension extends CardUIExtension {

  addingDocForCancelling: boolean = false;

  /** В ВНД дополнительно добавляется кнопка для добавления отменяемого документа. */
  public RdndInitialized(context: ICardUIExtensionContext)
  {
    const card = context.model.card;
    let refsTable = context.model.controls.get('RefsTable') as GridViewModel;
      if (card.typeId == CdCardTypes.RdndTypeID)
      {
          let buttonForCancelling = new UIButton(
              "Добавить отменяемый документ",
              async () =>
              {
                  this.addingDocForCancelling = true;
                  await refsTable.addRow();
                  this.addingDocForCancelling = false;
              });
          
              
          refsTable.rightButtons.push(buttonForCancelling);
      }
  }

  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }

    if (!(CdCardTypes.RefsTableSupportedCardTypes.indexOf(context.model.card.typeId) > -1) && 
        !(PkCardTypes.RefsTableSupportedCardTypes.indexOf(context.model.card.typeId) > -1)) {
    return;
    }
    let section = context.model.card.sections.tryGet('PkReferencesVirtual');
    if (section == null) return;

    let refsTable = context.model.controls.get('RefsTable') as GridViewModel;
    if (refsTable != null) {

      let isContextMenuEdit = false;

      refsTable.leftButtons.push(new UIButton("Редактировать", () =>
      {
        isContextMenuEdit = true;
        refsTable.editRow(refsTable.selectedRow);
      }));
   
      
      
     
      if (context.model.card.typeId == CdCardTypes.IrdDocumentTypeID // TES-10558 в ИРД скрыть кнопки "Редактировать", "Добавить", "Удалить"  для блока "Ссылки" 
        || context.model.card.typeId == CdCardTypes.ArDocumentIdpTypeID// TES-12239 в ИДП скрыть кнопки "Редактировать", "Добавить", "Удалить"  для блока "Ссылки" 
        || context.model.card.typeId == PkCardTypes.PkWorkOrderTypeID // TES-12242 в НЗ скрыть кнопки "Редактировать", "Добавить", "Удалить"  для блока "Ссылки" 
        || context.model.card.typeId == PkCardTypes.PkProtocolTypeID // TES-12243 Отключение Протоколов
        || context.model.card.typeId == CdCardTypes.PkRequestForMaterialsTypeID // TES-12240 Отключение Заявок на материалы
        || context.model.card.typeId == CdCardTypes.PkExecutiveDocumentationTypeID // TES-12553 Отключение ИД
        || context.model.card.typeId == CdCardTypes.PkExecutiveSchemeTypeID  // TES-12554 Отключение ИС
        || context.model.card.typeId == CdCardTypes.TechnicalDocumentationTypeID // TES-12555 Отключение ТД          
        )
      {
        refsTable.leftButtons.pop();
        refsTable.rightButtons.pop();
      }

      refsTable.rowInitializing.add(async () => {
        isContextMenuEdit = false;
      });

      refsTable.rowInvoked.add(async e => {
        if (e.action == GridRowAction.Opening && !isContextMenuEdit)
        {
          if (section == null) return;
          
          // TES-12295 Отключить возможность переходов по ссылкам в ИРД и ИДП
          if (context.model.card.typeId == CdCardTypes.IrdDocumentTypeID 
            || context.model.card.typeId == CdCardTypes.ArDocumentIdpTypeID
            || context.model.card.typeId == PkCardTypes.PkWorkOrderTypeID // TES-12242 Отключить возможность переходов по ссылкам в НЗ
            || context.model.card.typeId == PkCardTypes.PkProtocolTypeID // TES-12243 Отключение Протоколов
            || context.model.card.typeId == CdCardTypes.PkRequestForMaterialsTypeID // TES-12240 Отключение Заявок на материалы
            || context.model.card.typeId == CdCardTypes.PkExecutiveDocumentationTypeID // TES-12553 Отключение ИД
            || context.model.card.typeId == CdCardTypes.PkExecutiveSchemeTypeID  // TES-12554 Отключение ИС
            || context.model.card.typeId == CdCardTypes.TechnicalDocumentationTypeID // TES-12555 Отключение ТД            
          ) {
            e.cancel = true;
            return;
          }

          let cardId = e.row.get("DocID");
          await openCard({
            cardId: cardId,
          });
          e.cancel = true;
          return;
        }
      });
      
      
      refsTable.rowAdding.add(async e => {
        if (section == null) return;
        let refSection = "DocChRefsSection";
        let refType: NamedEntry | null = CdReferenceTypes.LinkDocuments;
        let nameParamList : RequestParameter[] = [];
        if (context.model.card.typeId === CdCardTypes.ArActTypeID ||
            context.model.card.typeId === CdCardTypes.ArContractTypeID ||
            context.model.card.typeId === CdCardTypes.ArEDocumentTypeID) {
          refSection = "DocChRefsSectionForActs";




          // представление выводим с параметром ид карточки.
          // Описание параметра
          const parameterMetadata = new ViewParameterMetadata();
          parameterMetadata.alias = 'CardID';
          parameterMetadata.caption = 'ID карточки';
          parameterMetadata.hidden = true;
          parameterMetadata.dataType = DbType.Guid;
          parameterMetadata.multiple = false;

          nameParamList = [new RequestParameterBuilder()
            .withMetadata(parameterMetadata)
            .addCriteria(equalsCriteriaOperator(), '', context.model.card.id )
            .asRequestParameter()];
        }

        if (context.model.card.typeId === CdCardTypes.RdndTypeID){
          // TES-8960 Выводить справочник "Все документы", ограниченный по условию:
          // 1. Тип документа = "Внутренние нормативные документы" и "Распорядительные документы"
          // 2. В Состоянии "Действующий"

          const parameterDocTypeMetadata = new ViewParameterMetadata();
          parameterDocTypeMetadata.alias = 'Value';
          parameterDocTypeMetadata.caption = 'Тип документа';
          parameterDocTypeMetadata.hidden = false;
          parameterDocTypeMetadata.dataType = DbType.Guid;
          parameterDocTypeMetadata.multiple = true;

          const parameterStatusMetadata = new ViewParameterMetadata();
          parameterStatusMetadata.alias = 'StateName';
          parameterStatusMetadata.caption = 'Состояние';
          parameterStatusMetadata.hidden = false;
          parameterStatusMetadata.dataType = DbType.Int32;
          parameterStatusMetadata.multiple = true;

          nameParamList = [
            new RequestParameterBuilder()
            .withMetadata(parameterDocTypeMetadata)
            .addCriteria(equalsCriteriaOperator(), "Внутренний нормативный документ", PkCardTypes.PkInternalDocumentationTypeID )
            .addCriteria(equalsCriteriaOperator(), "ОРД", PkCardTypes.RdndTypeID )
            .asRequestParameter(),

            new RequestParameterBuilder()
            .withMetadata(parameterStatusMetadata)
            .addCriteria(equalsCriteriaOperator(), CdDocStates.Active.caption, CdDocStates.Active.id )
            .asRequestParameter()
          ];

          refType = CdReferenceTypes.CancellInternalDocuments;
        }

        await showViewsDialog(
          refSection, 
          async (value) => {
            if (!value) {
              return;
            }
            let selectedItem = value;

            if (selectedItem == null
                || !selectedItem.selectedRow
                || !section) {
                e.cancel = true;
                return;
            }
    
            let selectedRow = selectedItem.selectedRow;
            if (selectedRow == null) {
              e.cancel = true;
              return;
            }
            let desc = selectedRow.get("Subject");
            if (desc == null) desc = "";
            let row = new CardRow();
            row.rowId = Guid.newGuid();
            if (selectedRow.has("DocID")) {
              CdCommonHelper.SetValueToRowField(row, "DocID", selectedRow.get("DocID"), DotNetType.Guid);
            }
            else {
              CdCommonHelper.SetValueToRowField(row, "DocID", selectedRow.get("ContractID"), DotNetType.Guid);
            }
            if (selectedRow.has("DocNumber")) {
              CdCommonHelper.SetValueToRowField(row, "DocDescription", selectedRow.get("DocNumber"), DotNetType.String);
            }
            else {
              CdCommonHelper.SetValueToRowField(row, "DocDescription", selectedRow.get("ContractNumberVirtual"), DotNetType.String);
            }
            if (selectedRow.has("DocNumber")) {
              CdCommonHelper.SetValueToRowField(row, "Number", selectedRow.get("DocNumber"), DotNetType.String);
            }
            else {
              CdCommonHelper.SetValueToRowField(row, "Number", selectedRow.get("ContractNumberVirtual"), DotNetType.String);
            }
            CdCommonHelper.SetValueToRowField(row, "DocDate", selectedRow.get("DocDate"), DotNetType.DateTime);
            row.set("Order", createTypedField(section.rows.length, DotNetType.Int32));
            CdCommonHelper.SetValueToRowField(row, "CardTypeName", selectedRow.get("CardTypeTitle"), DotNetType.String);
            CdCommonHelper.SetValueToRowField(row, "StateName", selectedRow.get("StateName"), DotNetType.String);
            row.set("Description", createTypedField(desc.Length > 128 ? (desc as string).substring(0, 128) : desc, DotNetType.String));
			        row.set("RefTypeID", createTypedField(refType!.id, DotNetType.Guid));
            row.set("RefTypeName", createTypedField(refType!.name, DotNetType.String));
            row.set("IsVirtual", createTypedField(true, DotNetType.Boolean));
    
            row.state = CardRowState.Inserted;
            section.rows.push(row);
    
            e.cancel = true;
          }, 
          nameParamList
        );

        
      });

      this.RdndInitialized(context);
    }
  }
}